// extracted by mini-css-extract-plugin
export default {"optionsWrapper":"z4kb2","ValidateArea":"SF1t2","ValidateButton":"ZICQY"};